import {
  REQUEST_USER,
  CONFIRM_USER,
} from './constants'

export function requestUser (userId, username) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: REQUEST_USER,
      payload: mapmy.requestUser(userId, username),
    })
  }
}

export function confirmUser (confirmationCode) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: CONFIRM_USER,
      payload: mapmy.confirmUser(confirmationCode),
    })
  }
}
